export default __webpack_public_path__ + "static/media/video11-1.a6b2dfa5.webp";